<div class="d-flex justify-content-center no-longer-valid-container">
  <div class="d-flex w-100 invalid-container justify-content-center align-items-center">
    <div class="d-flex align-items-center">
      <tds-icon [name]="'link_broken'" size="3rem"></tds-icon>
    </div>
    <div class="px-3">
      <span
        ><h3>{{ 'SP_LinkNoLongerValid' | translate }}</h3>
      </span>
    </div>
  </div>
</div>
